import { render, staticRenderFns } from "./RsaConfigurazioneAreeEditComponent.vue?vue&type=template&id=f686de14"
import script from "./RsaConfigurazioneAreeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAreeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports